export function addStringIfNotExists(array: string[], str: string) {
  return array.includes(str) ? array : [...array, str];
}
